import { render, staticRenderFns } from "./cancelReason.vue?vue&type=template&id=68e1c856&"
import script from "./cancelReason.vue?vue&type=script&lang=js&"
export * from "./cancelReason.vue?vue&type=script&lang=js&"
import style0 from "./cancelReason.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports